<template><section><h1>Icon</h1>
<blockquote>
<p>图标</p>
</blockquote>
<h2>代码示例</h2>
<p><test></test></p>

<h2>API</h2>
<table>
<thead>
<tr>
<th>参数</th>
<th style="text-align:left">说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>name</td>
<td style="text-align:left">图标类型</td>
<td><code>String</code></td>
<td>-</td>
</tr>
<tr>
<td>size</td>
<td style="text-align:left">图标尺寸</td>
<td><code>Number</code></td>
<td>-</td>
</tr>
<tr>
<td>color</td>
<td style="text-align:left">图标颜色</td>
<td><code>String</code></td>
<td>-</td>
</tr>
<tr>
<td>rotate</td>
<td style="text-align:left">是否旋转</td>
<td><code>Boolean</code></td>
<td><code>false</code></td>
</tr>
</tbody>
</table>
<h2>图标列表</h2>
<blockquote>
<p>点击图标复制代码</p>
</blockquote>
<p><IconList></IconList></p>
</section></template>

<script>
  import test from '@/pages/demo/Icon.vue';

  export default {
    components: {
      test
    }
  }
</script><script>
  import test from '@/pages/demo/Icon.vue';
  import IconList from '@/pages/demo/IconList.vue';

  export default {
    components: {
      test,
      IconList
    }
  }
</script>


// WEBPACK FOOTER //
// index-3.vue?3b08d78d